import React from 'react';

import { DesktopUserEnteringPage } from './DesktopUserEnteringPage';
import { DesktopUserEnteringContainerProps } from './types';

const  DesktopUserEnteringContainer: React.FC<DesktopUserEnteringContainerProps> = ({
  error,
  handlePayButtonClick,
  handleUserSearchButton,
  textInput,
  onTextInputChange
}) => {

  return (
    <DesktopUserEnteringPage
      error={error}
      handlePayButtonClick={handlePayButtonClick}
      handleUserSearchButton={handleUserSearchButton}
      textInput={textInput}
      onTextInputChange={onTextInputChange}
    />
  );
};

export default  DesktopUserEnteringContainer;
